// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3j7i_","right":"Footer_right__34Lnq","buttons":"Footer_buttons__1YGSu"};